import { activeSteps, STEP_LABELS } from '@components/Checkout/utils/stepConfig';
import type { CheckoutStep } from '@t/checkout.types';

export interface CheckoutStepDescriptor {
  key: CheckoutStep;
  label: string;
  number: number;
}

export const getCheckoutSteps = (hasPhonePlan: boolean, hasInstallationRequired = false): CheckoutStepDescriptor[] =>
  activeSteps({ hasPhonePlan, hasInstallationRequired }).map((key, i) => ({
    key,
    label: STEP_LABELS[key],
    number: i + 1,
  }));
